import { defineSong } from '../types';

export default defineSong({
  id: 'mavi-blues',
  title: 'Mavi Blues',
  level: 2,
  key: 'A',
  bpm: 92,
  beats: 4,
  pattern: 'D-DU-DU-',
  style: 'Blues',
  desc: "12 ölçülük blues, {{pc:A}}'da. Bütün akorlar dominant 7'li.",
  palette: ['A7', 'D7', 'E7', 'A', 'D', 'E', 'Bm', 'F#m'],
  sections: [
    { name: '1–4. ölçüler', bars: ['A7', 'A7', 'A7', 'A7'] },
    { name: '5–8. ölçüler', bars: ['D7', 'D7', 'A7', 'A7'] },
    { name: '9–12. ölçüler', bars: ['E7', 'D7', 'A7', 'E7'] },
  ],
  // Original lyrics written for kulaktan.com; each word with its length in beats.
  lyrics: [
    { bar: 1, text: 'Sabah:2 uyandım,:2 gökyüzü:2 mavi:2' },
    { bar: 5, text: 'Sabah:2 uyandım,:2 içim:2 de:1 mavi:1' },
    { bar: 9, text: 'Gitarımı:3 aldım,:1 dağıldı:2 kaygı:2' },
  ],
});
